import { useTheme } from '@mui/material'
import * as Styled from '../containers/styled'
import { Spinner } from 'assets/icons'

export interface LoadingContainerProps {
  loading: number
  dontShowSpinner?: boolean
}

export default function LoadingContainer(props: LoadingContainerProps) {
  const theme = useTheme()
  return (
    <Styled.LoadingOverlay
      style={{
        opacity: props.loading ? 0.5 : 0,
        backgroundColor: theme.palette.border.primary
      }}
      loading={props.loading ? 1 : 0}
    >
      {!props.dontShowSpinner && (
        <Styled.LoadingSpinner loading={props.loading ? 1 : 0} />
      )}
    </Styled.LoadingOverlay>
  )
}
